<ui-card [class.loading]="isLoading">
    <app-segment-header title="time-off-v3.policyComponents.enrolled-employees.header">
        <div class="buttons">
            <ui-button
                type="link"
                [routerLink]="['/time-off', 'v3', 'types-and-policies', 'policy', 'assign', timeOffPolicy.id]"
            >
                {{ 'edit' | translate }}
            </ui-button>
        </div>
    </app-segment-header>

    <div class="margin-bottom-3">
        <app-search #searchBar placeholder="search" (onSearch)="onSearch($event)"></app-search>
    </div>
    <app-simple-table
        *ngIf="rows.length; else empty"
        [attr.data-cy]="'enrolledEmployeesTable'"
        [columns]="columns"
        [rows]="rows"
        [fixedHeight]="true"
    ></app-simple-table>

    <!-- Empty State -->
    <ng-template #empty>
        <app-empty-state
            [class.hidden]="isLoading"
            label="time-off-v3.policyComponents.enrolled-employees.noResults"
            src="/assets/illustrations/chair.png"
        ></app-empty-state>
    </ng-template>
</ui-card>
